import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import get from 'lodash/get';
import {resourcesSelector} from 'resources/selectors';
import StepManagementAccordion from 'components/steps/StepManagementAccordion';
import AddStepsModalContainer from 'pages/ViewAllPlatforms/AddSteps/AddStepsModalContainer';
import {startAddStepsAction} from 'pages/ViewAllPlatforms/actions';
import {deletedResourceAction, saveResourceFieldAction} from "../resources/actions";
import {startDeleteAction} from "../pages/DeleteConfirmation/actions";
import RenameStepModalContainer from 'components/steps/RenameStep/RenameStepModalContainer';
import {startRenameStepAction} from 'pages/EditBreak/actions';
import {extractResourceIdsWithPath, makeBreakStepSectionKey, TopLevelSectionName} from "../utils/DBUtils";
import * as ResourceApi from "../api/resources";
import {toggleSectionOpen} from "utils/sectionManagement/actions";

const mapStateToProps = state => {
  const brk = get(state.editBreak, 'break', null);

  if (!brk) {
    return {
      break: null,
      masterResourceId: {}
    };
  } else {
    const resources = resourcesSelector(state.resources);
    const { savingStepOrder } = state.viewAllPlatforms;

    const breaksByPlatform = Object.keys(brk).reduce((breaks, key) => {
      const id = brk[key];
      breaks[key] = get(resources, id, null);
      return breaks;
    }, {});

    return {
      break: breaksByPlatform,
      masterResourceId: breaksByPlatform.MASTER.resourceId,
      savingStepOrder
    };
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  let {formProxy} = ownProps;
  let brk = formProxy.currentBaseResource;
  let resourceIds = extractResourceIdsWithPath(formProxy.baseResource["MASTER"], formProxy.currentBaseResource, formProxy.resourcePath);
  return {

      ...bindActionCreators({
          saveStepNumbers: (newStepOrder) => {
              return saveResourceFieldAction(
                  brk.resourceId,
                  brk.resourceId,
                  [],
                  ['breakStepsOrder'],
                  'breakStepsOrder',
                  newStepOrder,
                  [brk.resourceId],
                  [],
                  [],
                  false
              )
          },
          openAddStepsModal: startAddStepsAction,
          openRenameStepModal: startRenameStepAction,
          deleteStep: (step, index) => startDeleteAction(
              step,
              {type: ResourceApi.Types.BreakStep, id: step.id},
              resourceIds,
              {stepIds: [step.id]},
              [
                deletedResourceAction(
                  step,
                  brk,
                  resourceIds,
                  ['steps'],
                  ['steps']
                )
              ]
          ),
          togglePublishStep: (step, index) => saveResourceFieldAction(
              step.resourceId,
              brk.resourceId,
              [`steps.${index}`],
              [`steps.${index}.publishStep`],
              'publishStep',
              !step.publishStep,
              resourceIds.concat(step.resourceId),
              [],
              []
          ),
          onStepClick: (step, index) => toggleSectionOpen(TopLevelSectionName, makeBreakStepSectionKey(step.id), true),
      }, dispatch)
  };
};

const StepManagementAccordionContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(StepManagementAccordion);

const BreakStepManagementAccordion = props => [
  <StepManagementAccordionContainer key='StepManagementAccordion' formProxy={props.formProxy} />,
  <RenameStepModalContainer key='RenameStepModal' formProxy={props.formProxy} />,
  <AddStepsModalContainer key='AddStepsModal' />
];

export default BreakStepManagementAccordion;



// WEBPACK FOOTER //
// ./public/hoc/BreakStepManagementAccordion.js